module.exports = __webpack_public_path__ + "static/media/400046_02.622d9b6c.png";